import { Component, OnInit, Input } from '@angular/core';
import { HttpServiceService } from 'app/service/http-service.service';
import { error } from 'util';

@Component({
  selector: 'app-shareholder-google',
  templateUrl: './shareholder-google.component.html',
  styleUrls: ['./shareholder-google.component.scss']
})
export class ShareholderGoogleComponent implements OnInit {
  htmlBinding = '';
  @Input('firstName')
  firstName: any;
  @Input('lastName')
  lastName: any;

  constructor(private httpService: HttpServiceService) {}

  ngOnInit() {
    $('#linkReadMore').hide();
    this.httpService.searchGoogle(this.firstName + '+' + this.lastName).then(
      res => {
        const resText = `${res}`;
        // get data from Google and then filter unused data, we not separate anew function due to JavaScript properties pass by value
        const tempElement = document.createElement('div');
        tempElement.setAttribute('id', 'tempDOM');
        tempElement.style.display = 'none';
        tempElement.innerHTML = resText.replace(
          '.g,body,html,input,.std,h1{font-size:small;font-family:arial,sans-serif}',
          ''
        );
        Array.from(tempElement.querySelectorAll('.st')).forEach(x =>
          x.setAttribute('style', 'font-size: 1.2rem')
        );
        Array.from(tempElement.querySelectorAll('span')).forEach(x =>
          x.setAttribute('style', 'font-size: 1.25rem')
        );
        Array.from(tempElement.querySelectorAll('a')).forEach(x =>
          x.setAttribute('style', 'font-size: 1.5rem')
        );
        Array.from(tempElement.querySelectorAll('.sfbgx')).forEach(x =>
          x.setAttribute('style', 'width: 0%; min-width: 0px')
        );
        tempElement.querySelector('meta').remove();
        tempElement.querySelector('#fbarcnt').remove();
        tempElement.querySelector('#searchform').remove();
        tempElement.querySelector('#extrares').remove();
        tempElement.querySelector('#foot').remove();
        tempElement.querySelector('#hdtb-msb').remove();
        tempElement.querySelector('#hdtbSum').remove();
        tempElement.querySelector('#extabar').remove();
        tempElement.querySelector('#top_nav').remove();
        tempElement.querySelector('#sform').remove();
        tempElement
          .querySelector('#center_col')
          .setAttribute('style', 'margin-left: 0px; margin-right: 0px;');

        const allTagA = tempElement.getElementsByTagName('a');
        let i;
        for (i = 0; i < allTagA.length; i++) {
          allTagA[i].setAttribute('target', '_blank');
        }

        $('#loadingGoogle').hide();
        $('#linkReadMore').show();
        this.htmlBinding = tempElement.innerHTML;
        const path = `https://www.google.co.th/search?q=${this.firstName}+${
          this.lastName
        }&tbm=nws&tbas=0&source=lnt&sa=X&ved=0ahUKEwjJrKi0-ZjbAhXPfCsKHZ2vDwcQpwUIHg&biw=1680&bih=909&dpr=2`;
        document.querySelector('#linkReadMore').setAttribute('href', path);
      },
      err => {
        console.log(err.status + ' ' + err.statusText);
      }
    );
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/shareholder/shareholder-google/shareholder-google.component.ts